const login = [
    { type: 'required', message: 'You have entered wrong credentials, try again'}
]

export default {login};